export const RUTUBE_HOST = 'https://rutube.ru';
